import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from '@tanstack/react-router';

import { kinds } from '@/app/site/scope';
import { CatalogHead } from '@/features/catalog/Catalog';
import catalog from '@/features/catalog/Catalog.module.scss';
import { useSchemaTypes } from '@/features/catalog/useSchemaTypes';

import { TypeSettingsForm } from '../SchemaPage/TypeSettingsForm';

/**
 * Новая модель или новый компонент — страница, а не всплывающее окно:
 * после создания открывается деталка на вкладке «Поля».
 */
export function NewTypePage({ section }: { section: 'model' | 'component' | 'form' }) {
  const { siteId, env } = useParams({ from: '/authed/sites/$siteId/$env' });
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const types = useSchemaTypes(siteId, env);

  const groups = [
    ...new Set(
      (types.data ?? [])
        .filter((type) => type.kind === 'block' && type.folder !== '')
        .map((type) => type.folder),
    ),
  ];

  return (
    <div className={catalog['page']}>
      <CatalogHead
        title={
          section === 'component'
            ? 'Новый компонент'
            : section === 'form'
              ? 'Новая форма'
              : 'Новая модель'
        }
        subtitle={
          section === 'component'
            ? 'Секция страницы: её поля и группа. Поля добавите на следующем шаге.'
            : section === 'form'
              ? 'Форма принимает заявки с сайта: имя, телефон, сообщение — какие поля нужны. Поля добавите на следующем шаге.'
              : 'Модель описывает записи: какие у них поля и как они называются. Поля добавите на следующем шаге.'
        }
      />
      <TypeSettingsForm
        siteID={siteId}
        environment={kinds[env]}
        section={section}
        groups={groups}
        onSaved={(created) => {
          void queryClient.invalidateQueries({ queryKey: ['content-types', siteId] });

          if (section === 'form') {
            void navigate({
              to: '/sites/$siteId/$env/forms/$typeId',
              params: { siteId, env, typeId: created.id },
              search: { tab: 'fields' },
            });
          } else if (section === 'component') {
            void navigate({
              to: '/sites/$siteId/$env/components/$typeId',
              params: { siteId, env, typeId: created.id },
            });
          } else {
            void navigate({
              to: '/sites/$siteId/$env/models/$typeId',
              params: { siteId, env, typeId: created.id },
              search: { tab: 'fields' },
            });
          }
        }}
      />
    </div>
  );
}
